import { createTheme } from "@mui/material/styles";

const basePalette = {
    primary: {
        main: "#2b6cb0",
    },
    secondary: {
        main: "#ed8936",
    },
    accent: {
        main: "#38b2ac",
    },
};

const lightTheme = createTheme({
    palette: {
        mode: "light",
        ...basePalette,
        background: {
            default: "#f5f7fa",
            paper: "#ffffff",
        },
        text: {
            primary: "#1a202c",
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
    },
    shape: {
        borderRadius: 10,
    },
    transitions: {
        custom: {
            smooth: "background-color 0.5s ease-in-out, color 0.5s ease-in-out",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    transition:
                        "background-color 0.5s ease-in-out, color 0.5s ease-in-out",
                },
            },
        },
    },
});

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        ...basePalette,
        background: {
            default: "#1a202c",
            paper: "#2d3748",
        },
        text: {
            primary: "#f7fafc",
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
    },
    shape: {
        borderRadius: 10,
    },
    transitions: {
        custom: {
            smooth: "background-color 0.5s ease-in-out, color 0.5s ease-in-out",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    transition:
                        "background-color 0.5s ease-in-out, color 0.5s ease-in-out",
                },
            },
        },
    },
});

export { lightTheme, darkTheme };
